(function () {
  var root = document.querySelector("[data-collection]");
  if (!root) return;

  var grid = root.querySelector("[data-collection-grid]");
  var moreBtn = root.querySelector("[data-collection-more]");
  var scrollTopBtn = root.querySelector("[data-collection-scroll-top]");
  var paginationNav = root.querySelector("[data-collection-pagination]");
  var countEl = root.querySelector("[data-collection-count]");
  var sectionId = root.getAttribute("data-section-id");
  var baseCollectionUrl = root.getAttribute("data-collection-url");
  var currentCollectionUrl = baseCollectionUrl;
  var currentPage = parseInt(root.getAttribute("data-current-page"), 10) || 1;
  var totalPages = parseInt(root.getAttribute("data-total-pages"), 10) || 1;
  var totalItems = parseInt(root.getAttribute("data-total-items"), 10) || 0;
  var nextPage = currentPage + 1;
  var currentSort = root.getAttribute("data-default-sort") || "best-selling";
  var activeFilter = "all";
  var loading = false;

  // ─── Sort ───
  var sortRoot = root.querySelector("[data-collection-sort]");
  if (sortRoot) {
    var sortToggle = sortRoot.querySelector("[data-sort-toggle]");
    var sortDropdown = sortRoot.querySelector("[data-sort-dropdown]");
    var sortLabel = sortRoot.querySelector("[data-sort-label]");
    var sortOptions = sortRoot.querySelectorAll("[data-sort-option]");
    var sortClosers = sortRoot.querySelectorAll("[data-sort-close]");

    function openSort() {
      sortDropdown.hidden = false;
      sortToggle.setAttribute("aria-expanded", "true");
      if (window.matchMedia("(max-width: 768px)").matches) {
        document.body.classList.add("is-menu-open");
      }
    }

    function closeSort() {
      sortDropdown.hidden = true;
      sortToggle.setAttribute("aria-expanded", "false");
      document.body.classList.remove("is-menu-open");
    }

    sortToggle.addEventListener("click", function (e) {
      e.stopPropagation();
      sortDropdown.hidden ? openSort() : closeSort();
    });

    sortClosers.forEach(function (el) {
      el.addEventListener("click", closeSort);
    });

    sortOptions.forEach(function (option) {
      option.addEventListener("click", function () {
        var value = option.getAttribute("data-sort-value");
        var label = option.getAttribute("data-sort-label") || option.textContent.trim();

        sortOptions.forEach(function (item) {
          item.classList.remove("is-active");
          item.setAttribute("aria-selected", "false");
        });
        option.classList.add("is-active");
        option.setAttribute("aria-selected", "true");

        if (sortLabel) sortLabel.textContent = label;
        closeSort();

        currentSort = value;
        reloadCollection(1);
      });
    });

    document.addEventListener("click", function (e) {
      if (sortDropdown.hidden) return;
      if (sortRoot.contains(e.target)) return;
      closeSort();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !sortDropdown.hidden) closeSort();
    });

    window.addEventListener("resize", function () {
      if (sortDropdown.hidden) return;
      if (!window.matchMedia("(max-width: 768px)").matches) {
        document.body.classList.remove("is-menu-open");
      }
    });
  }

  // ─── Cross-collection filter ───
  var catButtons = root.querySelectorAll("[data-cross-collection]");
  catButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var handle = btn.getAttribute("data-cross-collection");
      if (handle === activeFilter) return;

      catButtons.forEach(function (b) { b.classList.remove("is-active"); });
      btn.classList.add("is-active");
      activeFilter = handle;

      if (handle === "all") {
        currentCollectionUrl = baseCollectionUrl;
      } else {
        currentCollectionUrl = "/collections/" + handle;
      }

      reloadCollection(1);
    });
  });

  // ─── AJAX helpers ───
  function buildUrl(page) {
    return currentCollectionUrl + "?page=" + page + "&sort_by=" + currentSort + "&section_id=" + sectionId;
  }

  function fetchSection(url) {
    return fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        return parser.parseFromString(html, "text/html");
      });
  }

  // ─── Show more (append next page) ───
  if (moreBtn) {
    moreBtn.addEventListener("click", function () {
      if (loading || nextPage > totalPages) return;
      loading = true;
      moreBtn.disabled = true;

      fetchSection(buildUrl(nextPage)).then(function (doc) {
        var newGrid = doc.querySelector("[data-collection-grid]");
        if (newGrid) {
          var cards = newGrid.querySelectorAll("[data-product-card]");
          cards.forEach(function (card) {
            grid.appendChild(card);
          });
        }

        nextPage++;
        if (nextPage > totalPages) {
          moreBtn.hidden = true;
        }

        bindCartButtons();
        loading = false;
        moreBtn.disabled = false;
      }).catch(function () {
        loading = false;
        moreBtn.disabled = false;
      });
    });
  }

  // ─── Full page reload (sort change / pagination click / filter change) ───
  function reloadCollection(page) {
    if (loading) return;
    loading = true;

    fetchSection(buildUrl(page)).then(function (doc) {
      var newRoot = doc.querySelector("[data-collection]");
      if (!newRoot) { loading = false; return; }

      var newGrid = newRoot.querySelector("[data-collection-grid]");
      var newPagination = newRoot.querySelector("[data-collection-pagination]");
      var newTotalPages = parseInt(newRoot.getAttribute("data-total-pages"), 10) || 1;
      var newTotalItems = parseInt(newRoot.getAttribute("data-total-items"), 10) || 0;

      if (newGrid) {
        grid.className = newGrid.className;
        grid.innerHTML = newGrid.innerHTML;
      }

      if (paginationNav && newPagination) {
        paginationNav.innerHTML = newPagination.innerHTML;
        bindPaginationLinks();
      } else if (paginationNav && !newPagination) {
        paginationNav.innerHTML = "";
      }

      currentPage = page;
      totalPages = newTotalPages;
      totalItems = newTotalItems;
      nextPage = page + 1;

      if (moreBtn) {
        moreBtn.hidden = nextPage > totalPages;
      }

      if (countEl) {
        countEl.textContent = totalItems + " items";
      }

      root.setAttribute("data-current-page", currentPage);
      root.setAttribute("data-total-pages", totalPages);

      bindCartButtons();
      loading = false;

      root.scrollIntoView({ behavior: "smooth", block: "start" });
    }).catch(function () {
      loading = false;
    });
  }

  // ─── Pagination links (AJAX) ───
  function bindPaginationLinks() {
    if (!paginationNav) return;
    paginationNav.querySelectorAll("[data-pagination-link]").forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        var href = link.getAttribute("href");
        var match = href.match(/[?&]page=(\d+)/);
        var page = match ? parseInt(match[1], 10) : 1;
        reloadCollection(page);
      });
    });
  }
  bindPaginationLinks();

  // ─── Scroll to top ───
  if (scrollTopBtn) {
    scrollTopBtn.addEventListener("click", function () {
      root.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }

  // ─── Cart add + variant modal ───
  var variantModal = document.querySelector("[data-collection-variant-modal]");
  var variantModalTitle = variantModal && variantModal.querySelector("[data-variant-modal-title]");
  var variantModalOptions = variantModal && variantModal.querySelector("[data-variant-modal-options]");
  var variantModalError = variantModal && variantModal.querySelector("[data-variant-modal-error]");
  var variantModalSubmit = variantModal && variantModal.querySelector("[data-variant-modal-submit]");
  var activeProductData = null;
  var selectedOptions = [];
  var activeTriggerBtn = null;

  function moneyFromCents(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents);
      }
    } catch (e) {}
    return "$" + (Number(cents) / 100).toFixed(2);
  }

  function getProductData(btn) {
    var card = btn.closest("[data-product-card]");
    if (!card) return null;
    var script = card.querySelector("[data-collection-product-json]");
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function findMatchingVariant(product, options) {
    if (!product || !product.variants) return null;
    return product.variants.find(function (variant) {
      return options.every(function (value, index) {
        var key = "option" + (index + 1);
        return !value || variant[key] === value;
      });
    }) || null;
  }

  function optionValuesForIndex(product, optionIndex) {
    var values = [];
    product.variants.forEach(function (variant) {
      var value = variant["option" + (optionIndex + 1)];
      if (value && values.indexOf(value) === -1) values.push(value);
    });
    return values;
  }

  function isOptionAvailable(product, optionIndex, value) {
    return product.variants.some(function (variant) {
      if (!variant.available) return false;
      if (variant["option" + (optionIndex + 1)] !== value) return false;
      return selectedOptions.every(function (selected, idx) {
        if (idx === optionIndex || !selected) return true;
        return variant["option" + (idx + 1)] === selected;
      });
    });
  }

  function renderVariantOptions() {
    if (!variantModalOptions || !activeProductData) return;
    variantModalOptions.innerHTML = "";

    activeProductData.options.forEach(function (optionName, optionIndex) {
      if (optionName === "Title") return;

      var values = optionValuesForIndex(activeProductData, optionIndex);
      if (!values.length) return;

      var group = document.createElement("div");
      group.className = "collection-variant-modal__group";

      var label = document.createElement("span");
      label.className = "collection-variant-modal__group-label";
      label.textContent = optionName;
      group.appendChild(label);

      var grid = document.createElement("div");
      grid.className = "collection-variant-modal__grid";
      grid.setAttribute("data-count", String(Math.min(values.length, 3)));

      values.forEach(function (value) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "collection-variant-modal__option";
        btn.textContent = value;
        btn.disabled = !isOptionAvailable(activeProductData, optionIndex, value);
        if (selectedOptions[optionIndex] === value) btn.classList.add("is-active");

        btn.addEventListener("click", function () {
          selectedOptions[optionIndex] = value;
          if (variantModalError) {
            variantModalError.hidden = true;
            variantModalError.textContent = "";
          }
          renderVariantOptions();
          syncModalSubmitState();
        });

        grid.appendChild(btn);
      });

      group.appendChild(grid);
      variantModalOptions.appendChild(group);
    });

    syncModalSubmitState();
  }

  function getModalCartIconSrc() {
    var triggerImg = activeTriggerBtn && activeTriggerBtn.querySelector("img");
    if (triggerImg) return triggerImg.getAttribute("src") || "";
    var submitImg = variantModalSubmit && variantModalSubmit.querySelector("img");
    return submitImg ? submitImg.getAttribute("src") || "" : "";
  }

  function setModalSubmitLabel(label) {
    if (!variantModalSubmit) return;
    var iconSrc = getModalCartIconSrc();
    variantModalSubmit.innerHTML =
      label + (iconSrc ? ' <img src="' + iconSrc + '" alt="" width="20" height="20" />' : "");
  }

  function requiredOptionIndexes(product) {
    var indexes = [];
    (product.options || []).forEach(function (name, index) {
      if (name !== "Title") indexes.push(index);
    });
    return indexes;
  }

  function syncModalSubmitState() {
    if (!variantModalSubmit || !activeProductData) return;
    var required = requiredOptionIndexes(activeProductData);
    var allSelected = required.every(function (index) {
      return Boolean(selectedOptions[index]);
    });
    var match = allSelected ? findMatchingVariant(activeProductData, selectedOptions) : null;
    var ready = Boolean(match && match.available);

    variantModalSubmit.disabled = !ready;
    if (ready) {
      setModalSubmitLabel("Add to cart · " + moneyFromCents(match.price));
    } else {
      setModalSubmitLabel("Add to cart");
    }
  }

  function openVariantModal(productData, triggerBtn) {
    if (!variantModal || !productData) return;
    activeProductData = productData;
    activeTriggerBtn = triggerBtn;
    selectedOptions = productData.options.map(function () {
      return "";
    });

    if (variantModalTitle) variantModalTitle.textContent = productData.title || "Select options";
    if (variantModalError) {
      variantModalError.hidden = true;
      variantModalError.textContent = "";
    }

    renderVariantOptions();
    variantModal.hidden = false;
    document.body.classList.add("is-menu-open");
  }

  function closeVariantModal() {
    if (!variantModal) return;
    variantModal.hidden = true;
    document.body.classList.remove("is-menu-open");
    activeProductData = null;
    activeTriggerBtn = null;
    selectedOptions = [];
  }

  function addVariantToCart(variantId, btn) {
    btn.disabled = true;
    var textEl = btn.querySelector("[data-collection-add-text]");
    var originalText = textEl ? textEl.textContent : "Add to cart";
    if (textEl) textEl.textContent = "Adding...";

    return fetch((window.__glowRoutes ? window.__glowRoutes.cartUrl : "/cart") + "/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error("Add failed");
        return res.json();
      })
      .then(function () {
        btn.classList.add("is-added");
        btn.setAttribute("aria-pressed", "true");
        btn.setAttribute("aria-label", "In cart");
        if (textEl) textEl.textContent = "In cart";
        var icon = btn.querySelector("[data-collection-add-icon]");
        if (icon) {
          var addedSrc = icon.getAttribute("data-icon-added");
          if (addedSrc) icon.src = addedSrc;
        }
        document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { openDrawer: true } }));
      })
      .catch(function () {
        if (textEl) textEl.textContent = originalText;
      })
      .finally(function () {
        btn.disabled = false;
      });
  }

  if (variantModal) {
    variantModal.querySelectorAll("[data-variant-modal-close]").forEach(function (el) {
      el.addEventListener("click", closeVariantModal);
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && variantModal && !variantModal.hidden) closeVariantModal();
    });

    if (variantModalSubmit) {
      variantModalSubmit.addEventListener("click", function () {
        if (!activeProductData) return;

        var required = requiredOptionIndexes(activeProductData);
        var allSelected = required.every(function (index) {
          return Boolean(selectedOptions[index]);
        });
        var match = allSelected ? findMatchingVariant(activeProductData, selectedOptions) : null;

        if (!match || !match.available) {
          if (variantModalError) {
            variantModalError.hidden = false;
            variantModalError.textContent = allSelected
              ? "That option is unavailable."
              : "Please select available options.";
          }
          return;
        }

        var trigger = activeTriggerBtn;
        closeVariantModal();
        if (trigger) {
          trigger.setAttribute("data-variant-id", String(match.id));
          addVariantToCart(match.id, trigger);
        }
      });
    }
  }

  function bindCartButtons() {
    grid.querySelectorAll("[data-collection-add]").forEach(function (btn) {
      if (btn.dataset.collectionBound) return;
      btn.dataset.collectionBound = "1";

      btn.addEventListener("click", function () {
        if (btn.classList.contains("is-added")) return;

        var card = btn.closest("[data-product-card]");
        if (card && card.getAttribute("data-has-variants") === "true") {
          var productData = getProductData(btn);
          if (productData) {
            openVariantModal(productData, btn);
            return;
          }
        }

        var variantId = btn.getAttribute("data-variant-id");
        if (!variantId) return;
        addVariantToCart(variantId, btn);
      });
    });
  }
  bindCartButtons();

  // ─── SEO show more / show less ───
  var seoRoot = root.querySelector("[data-collection-seo]");
  if (seoRoot) {
    var seoContent = seoRoot.querySelector("[data-seo-content]");
    var seoToggle = seoRoot.querySelector("[data-seo-toggle]");
    var SEO_COLLAPSED = 113;

    if (seoContent && seoToggle) {
      function seoCollapse() {
        seoContent.style.maxHeight = SEO_COLLAPSED + "px";
        seoRoot.classList.remove("is-open");
        seoToggle.textContent = "Show more";
      }

      function seoExpand() {
        seoContent.style.maxHeight = seoContent.scrollHeight + "px";
        seoRoot.classList.add("is-open");
        seoToggle.textContent = "Show less";
      }

      seoContent.addEventListener("transitionend", function (e) {
        if (e.target !== seoContent || e.propertyName !== "max-height") return;
        if (seoRoot.classList.contains("is-open")) seoContent.style.maxHeight = "none";
      });

      seoToggle.addEventListener("click", function () {
        if (seoRoot.classList.contains("is-open")) {
          seoContent.style.maxHeight = seoContent.scrollHeight + "px";
          seoContent.offsetHeight;
          seoCollapse();
          return;
        }
        seoExpand();
      });

      seoCollapse();

      window.addEventListener("resize", function () {
        if (!seoRoot.classList.contains("is-open")) {
          seoContent.style.maxHeight = SEO_COLLAPSED + "px";
          return;
        }
        seoContent.style.maxHeight = "none";
      });
    }
  }
})();
